module.exports = __webpack_public_path__ + "img/repert.621d908e.png";